import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { ISupplier, VisaSupplierBooking } from "../../../../Supplier"
import { useOutletContext } from "react-router"

export default function VisaBookingSuppliersPage() {
	const { transportServiceProvider } = useOutletContext<{
		transportServiceProvider: ISupplier
		revalidate: () => void
	}>()
	return (
		<ForbidUnlessAuthorized
			permission={PERMISSIONS.MANAGE_VISA_SUPPLIERS}
		>
			<Helmet>
				<title>Visa Bookings Supplier</title>
			</Helmet>
			<VisaSupplierBooking supplier={transportServiceProvider} />
		</ForbidUnlessAuthorized>
	)
}
